/**
* Created by vouill on 11/14/17.
*/

<template>
  <div class="row center-xs">
    <div class="col-xs-6 content">
      <slot/>
    </div>
  </div>
</template>

<style>
.content {
  text-align: left;
}
</style>
<script>
export default {
  name: "CenterContainer",
  props: {},
  components: {},
  data() {
    return {};
  }
};
</script>
